import { yupResolver } from "@hookform/resolvers/yup"
import { useState } from "react"
import * as yup from "yup"

import DialogProvider from "@components/dialog_provider"
// import TextInput from "@components/text_input"
import { useCustomerPageContext } from "@contexts/customer"
import useControlledForm from "@hooks/use_controlled_form"
import { Stack, Typography } from "@mui/material"
// import TextActionForm from "@components/text_action_form"

export type PaymentFormData = {
  paymentMethod: string
}

export default function RetryPaymentDialog({
  isOpen,
  setClose,
  onSubmition
  // currentInvoice
}: {
  isOpen: boolean
  setClose: () => void
  onSubmition: () => Promise<void>
  // currentInvoice: InvoiceData | undefined
}) {
  const { translate } = useCustomerPageContext()

  const schema = yup
    .object({
      paymentMethod: yup
        .string()
        .required(translate("payment_method_field_is_required"))
    })
    .required()

  const {
    // control,
    handleSubmit,
    reset,
    formState: { isValid }
  } = useControlledForm<PaymentFormData>({
    resolver: yupResolver(schema),
    mode: "all",
    defaultValues: {
      paymentMethod: "BANK_TRANSFER"
    }
  })

  const [loading, setLoading] = useState(false)

  function handleClose() {
    if (loading) {
      return
    }
    setClose()
    reset()
  }

  async function onSubmit() {
    setLoading(true)
    await onSubmition()
    setLoading(false)
    handleClose()
  }

  return (
    <DialogProvider
      title={translate("retry_payment")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: setClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("save"),
        color: "primary",
        onClick: handleSubmit(onSubmit),
        loading: loading,
        disabled: !isValid
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack justifyContent={"center"} alignItems={"center"} flex={1}>
        <Typography align="center">
          {translate("retry_payment_confirm")}
        </Typography>
      </Stack>
      {/* <Stack gap={1}>
        <Box sx={{ pt: 2 }}>
          <TextActionForm
            text={currentInvoice?.amountPaid}
            label={translate("amount")}
            backgroundColor="secondary"
          />
        </Box>
        <TextInput<PaymentFormData>
          type="select"
          label={translate("payment_method")}
          disabled={loading}
          name="paymentMethod"
          placeholder={translate("select")}
          control={control}
          selectOptions={[{ label: "Bank Transfer", value: "BANK_TRANSFER" }]}
        />
      </Stack> */}
    </DialogProvider>
  )
}
